"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.CardContent = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(StyledContainer, tslib_1.__assign({}, rest), children));
};
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 2.4rem;\n  height: 100%;\n"], ["\n  padding: 2.4rem;\n  height: 100%;\n"])));
var templateObject_1;
